<template>
  <div class="country-about">
    <Header :country_details="country_details" :meta="meta_info"/>
    <section class="university-about">
      <div class="container max-width ">
        <div class="row justify-content-center p-0 p-lg-5 my-3 mt-3 w-100">
          <div class="col-lg-7">
            <div class="box-shadow p-3 mb-3 mb-lg-5 w-100">
              <h4 class="main-heading-2 title primary-color p-3">
                Country Benefits
              </h4>
              <p class="main-content-1 text-left p-2">
                {{ country_details.country_benefits }}
              </p>
              <div class="container">
                <div class="row mt-5 gx-3 gy-3 lg-py-3 ">
                  <div class="col-md-4">
                    <div class="border rounded-3 p-3 card-col mb-2">
                      <div class="circle p-3 expense-card">
                        <img src="@/assets/imgs/svgs/Icon 05.svg" class="img-fluid" :alt="meta_info.alt"
                          style="width: 60px; height: 60px;" />
                      </div>
                      <div>
                        <p class="light-grey-3 pt-2">Cost</p>
                        <p class="font-weight-bold">
                          {{ country_details.country_mlc_amount }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="border rounded-3 card-col p-3 mb-2">
                      <div class="circle p-3 expense-card">
                        <img src="@/assets/imgs/svgs/Icon 04.svg" class="img-fluid" :alt="meta_info.alt"
                          style="width: 60px; height: 60px;" />
                      </div>
                      <div>
                        <p class="light-grey-3 pt-2">Rent</p>
                        <p class="font-weight-bold">
                          {{ country_details.country_mlc_rent }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="border rounded-3 card-col p-3 mb-2">
                      <div class="circle p-3 expense-card">
                        <img src="@/assets/imgs/svgs/Icon 03.svg" class="img-fluid" :alt="meta_info.alt"
                          style="width: 60px; height: 60px;" />
                      </div>
                      <div>
                        <p class="light-grey-3 pt-2">Meal</p>
                        <p class="font-weight-bold">
                          {{ country_details.country_mlc_meal }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gx-3 gy-3">
                  <div class="col-md-4">

                    <div class="border rounded-3 card-col p-3 mb-2">

                      <div class="circle p-3 expense-card">

                        <img src="@/assets/imgs/svgs/Icon 02.svg" class="img-fluid" :alt="meta_info.alt"
                          style="width: 60px; height: 60px;" />

                      </div>

                      <div>

                        <p class="light-grey-3 pt-2 ">Local Conveyance</p>

                        <p class="font-weight-bold">

                          {{ country_details.country_mlc_local_conveyance }}

                        </p>

                      </div>

                    </div>

                  </div>

                  <div class="col-md-4">

                    <div class="border rounded-3 card-col p-3 mb-2">

                      <div class="circle p-3 expense-card">

                        <img src="@/assets/imgs/svgs/Icon 01.svg" class="img-fluid" :alt="meta_info.alt"
                          style="width: 60px; height: 60px;" />

                      </div>

                      <div>

                        <p class="light-grey-3 pt-2 ">Personal Expense</p>

                        <p class="font-weight-bold">

                          {{ country_details.country_mlc_personal_expense }}

                        </p>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div class="box-shadow mb-3 p-5 mb-lg-5" id="about">

              <h4 class="main-heading-2 title primary-color">Benefits</h4>

              <div>

                <h6 class="secondary-title-space">Category</h6>

                <p class="main-content-2">

                  {{ country_details.country_visa_category }}

                </p>

              </div>

              <div class="pt-1">

                <h6 class="secondary-title-space">Documents</h6>

                <p class="main-content-2 text-left p-2">

                  {{ country_details.country_visa_documents }}

                </p>

              </div>

              <div class="pt-1" v-if="country_details.country_visa_fee">

                <h6 class="secondary-title-space">Fee</h6>

                <p class="main-content-2">

                  {{ country_details.country_visa_fee }}

                </p>

              </div>

            </div>

          </div>

          <div class="col-lg-5">

            <div class="box-shadow mb-3 mb-lg-5">

              <div class="">

                <h4 class="main-heading-2 title  primary-color">Details</h4>

                <p class="main-content-1 mt-3 text-left p-2">

                  {{ country_details.country_mlc_details }}

                </p>

              </div>

            </div>

            <div class="box-shadow" id="about">

              <h4 class="main-heading-2 title primary-color">Part Time Work</h4>

              <div>

                <h6 class="secondary-title-space">Details</h6>

                <p class="main-content-1 text-left p-2">

                  {{ country_details.country_ptw_details }}

                </p>

              </div>

              <div class="pt-4" v-if="country_details.country_ptw_useful_tips">

                <h6 class="secondary-title-space">Tips</h6>

                <p class="main-content-2 ">

                  {{ country_details.country_ptw_useful_tips }}

                </p>

              </div>

            </div>

          </div>

        </div>
        <div class="mb-5 mb-lg-5" v-if="country_details.country_mlc_saving_tips">
          <div>
            <img src="@/assets/imgs/svgs/alif-tips.svg" class="img-fluid" :alt="meta_info.alt"/>
          </div>
          <p class="main-content-1">
            {{ country_details.country_mlc_saving_tips }}
          </p>
          <button class="btn-secondary-red mt-5" @click="() => $router.push({ path: '/edgeout' })">
            Explore Edgeout
          </button>
        </div>


      </div>
    </section>
    <RecentPostSection />
  </div>
</template>
<script>
import homeServices from "@/apiServices/homeServices";
import Header from "./Navigation";
import { search_tags } from "@/data/homeData";
// import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import { meta_infos } from "@/data/metaInfoCountry";
export default {
  metaInfo() {
    return{
      title:
        `${this.meta_info.title}` ,
      htmlAttrs: {
        lang: "en-US",
      },
    }
    },
  components: {
    Header,
    // BookFreeCounselling,
    RecentPostSection,
  },
  watch: {
    "$route.params.country_key"(val) {
      this.getCountryDetails(val);
    }
  },
  data() {
    return {
      featured_universities: [],
      search_tags,
      filter: {
        searchText: "",
        course_level: null,
        course_category: null,
        country: null
      },
      country_id: null,
      country_key: null,
      country_details: {},
      topSchoolSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
      },
      meta_info:null, 


      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  methods: {
    async getData() {
      try {
        const featured_universities = await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    },
    async getCountryDetails(country_key) {
      try {
        const response = await homeServices.getCountryDetails({ country_key });
        if (response.data.status) {
          this.country_details = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting  ", err);
      }
    },
    onClickSearchTag(tag_obj) {
      switch (tag_obj.type) {
        case "country":
          this.filter.country = tag_obj;
          break;

        case "course_level":
          this.filter.course_level = tag_obj;
          break;

        case "course_category":
          this.filter.course_category = tag_obj;
          break;

        case "search":
          this.filter.searchText = tag_obj.name;
          break;
      }
      window.courseFilter = this.filter;
      this.$router.push("/search/search");
    },
    applyMeta(country){
      try {
        const data = meta_infos.find((elem)=> country === elem.country)
        this.meta_info = data
        console.log(this.meta_info)
      } catch (error) {
        console.log(error)
      }
    }
  },
  beforeMount() {
    this.getData();
    const { country_key } = this.$route.params;
    if (country_key) {
      this.country_key = country_key;
      this.getCountryDetails(country_key);
      this.applyMeta(country_key);
    }
    document.querySelector('meta[name="description"]').setAttribute('content',`${this.meta_info.description}`);

  }
};
</script>

<style>
.logo-card .logo-name {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.university-about .search-tags {
  justify-content: flex-start;
}

.max-width {
  max-width: 1536px;
}

.title {
  font-size: 2.5rem;
  font-weight: 500;
}

.logo-card {
  box-shadow: -4px -4px 4px rgba(255, 255, 255, 0.13),
    4px 4px 11px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  overflow: hidden !important;
}

.logo-img img {
  height: 80px;
  width: 200px;
  object-fit: contain;
  align-items: center;
  display: flex;
  justify-content: center;
}

.logo-card:hover {
  transform: scale(1.1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Country/About.vue